import helper from '../../helper'

export default {
	mounted() {
		if( helper.isMobile() )
			{
			const scrollInto = () =>
				{
				setTimeout(() => {
		            document.querySelector('form.register-form').scrollIntoView({
		                behavior: 'smooth'
		            })
		        }, 500);
				}

			if (window.location.href.indexOf('resetpassword') > -1)
				{
				window.addEventListener
					('load',
					function()
						{
						scrollInto();
						}
					)
				}
			else
				{
				scrollInto();
				}
			}
	}
}